import { NativeClientService } from '@shared/services/native-client.service';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AuthService } from './auth.service';
import { selectMinutesUntilAutoLogout } from '../store/selectors/app-config.selectors';
import { Store } from '@ngrx/store';

const CHECK_INTERVAL = 20000; // in ms
const STORE_KEY = 'lastAction';

@Injectable({
  providedIn: 'root',
})
export class AutoLogoutService {
  minutesToLogout: number;
  freeze: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public getLastAction() {
    try {
      return parseInt(localStorage.getItem(STORE_KEY));
    } catch (error) {
      console.error(
        'Chould not write last action time from local storage',
        error,
      );
    }
  }
  public setLastAction(lastAction: number) {
    try {
      localStorage.setItem(STORE_KEY, lastAction.toString());
    } catch (error) {
      console.error('Could not write last action time to local storage', error);
    }
  }
  constructor(
    private authService: AuthService,
    private nativeClientService: NativeClientService,
    private store: Store,
  ) {
    if (!this.nativeClientService.isNative) {
      this.setLastAction(Date.now());
      this.initListener();
      this.initInterval();
      this.store.pipe(selectMinutesUntilAutoLogout).subscribe((minutes) => {
        if (!minutes) {
          this.minutesToLogout = 10;
        } else {
          this.minutesToLogout = minutes;
        }
      });
    }
  }

  initListener() {
    // TODO debounce
    document.body.addEventListener('click', () => this.reset());
    document.body.addEventListener('mousemove', () => this.reset());
    document.body.addEventListener('touchstart', () => this.reset());
    document.body.addEventListener('keydown', () => this.reset());
    document.body.addEventListener('keyup', () => this.reset());
    document.body.addEventListener('keypress', () => this.reset());
  }
  reset() {
    this.setLastAction(Date.now());
    if (this.freeze.getValue()) {
      this.freeze.next(false);
    }
  }
  initInterval() {
    setInterval(() => {
      this.check();
    }, CHECK_INTERVAL);
  }
  check() {
    const now = Date.now();
    const timeleft = this.getLastAction() + this.minutesToLogout * 60 * 1000;
    const diff = timeleft - now;
    const isTimeout = diff < 0;

    if (
      new Date(diff).getMinutes() === 0 &&
      new Date(diff).getSeconds() <= 30 &&
      !this.freeze.getValue()
    ) {
      this.freeze.next(true);
    }
    if (isTimeout) {
      setTimeout(() => {
        localStorage.clear();
        this.authService.logoutOAuth();
      }, 3000);
    }
  }
}
